import { type FormEvent, useState } from 'react'
import { Button } from '@carouselgg/nexus/button'
import { Input } from '@carouselgg/nexus/input'
import { Text } from '@carouselgg/nexus/text'
import { Callout } from '@carouselgg/nexus/callout'
import { Mail } from '@carouselgg/nexus/icon'
import styles from './NewsletterForm.module.css'

type Status = 'idle' | 'loading' | 'success' | 'already_subscribed' | 'error'

export function NewsletterForm() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<Status>('idle')
  const [message, setMessage] = useState('')

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (!email.trim()) return

    setStatus('loading')
    try {
      const apiBase = import.meta.env.VITE_API_URL || '/api'
      const res = await fetch(`${apiBase}/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      })
      const data = await res.json()

      if (!res.ok) {
        throw new Error(data.error || 'Something went wrong')
      }

      setMessage(data.message)
      setStatus(data.status === 'already_subscribed' ? 'already_subscribed' : 'success')
    } catch (err) {
      setMessage(err instanceof Error ? err.message : 'Something went wrong. Please try again.')
      setStatus('error')
    }
  }

  if (status === 'success' || status === 'already_subscribed') {
    return (
      <Callout variant={status === 'already_subscribed' ? 'info' : 'success'} icon={true} className={styles.callout}>
        <Text size="sm">{message}</Text>
      </Callout>
    )
  }

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.row}>
        <Input
          type="email"
          placeholder="your@email.gg"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={status === 'error'}
          disabled={status === 'loading'}
          required
          className={styles.input}
        />
        <Button
          type="submit"
          variant="primary"
          size="md"
          disabled={status === 'loading'}
          className={styles.button}
        >
          <Mail size={16} />
          {status === 'loading' ? 'Subscribing…' : 'Subscribe'}
        </Button>
      </div>
      {status === 'error' && (
        <Text size="sm" className={styles.error}>{message}</Text>
      )}
    </form>
  )
}
